<template>
  <div class="dialog-box dialog-box-restore">
    <a class="dialog__back" :class="{disabled: inProcess}" @click="onBackLinkClicked" v-if="step < 4"
       data-qa="restore-dialog-link-back">
      <svg width="14" height="20" viewBox="0 0 14 20" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
        <path d="M5.1656e-07 10L11.8005 -9.61441e-08L14 1.86392L4.39899 10L14 18.1361L11.8005 20L5.1656e-07 10Z"/>
      </svg>
    </a>
    <div class="dialog">
      <template v-if="step === 1">
        <div class="dialog-head">
          <h3 class="dialog__title">Восстановление <br> пароля</h3>
          <p class="dialog__text">Введите Ваш личный <br> рабочий Email и СНИЛС</p>
        </div>
        <form class="dialog__form" @submit.prevent="submitStepOne({email, snils})">
          <div>
            <vita-input
              placeholder="Введите Email"
              type="mail"
              v-model="email"
              @input="validateEmail"
              :floating-label="true"
              data-qa="restore-dialog-input-email"
            />
            <vita-input
              placeholder="Введите СНИЛС"
              type="text"
              @input="validateSnils"
              v-model="snils"
              v-maska="'###-###-### ##'"
              inputmode="numeric"
              :floating-label="true"
              data-qa="restore-dialog-input-snils"
            />
          </div>
          <div>
            <vita-button :disabled="inProcess || isStepPassed(step)" :button-type="'submit'"
              data-qa="restore-dialog-button-next">Далее</vita-button>
            <div class="dialog__links">
              <a :class="{disabled: inProcess}" @click="goHomePage"
                 data-qa="restore-dialog-link-home">Главная страница</a>
            </div>
          </div>
        </form>
      </template>
      <template v-if="step === 2">
        <div class="dialog-head">
          <h3 class="dialog__title">Восстановление <br> пароля</h3>
          <p class="dialog__text">Введите номер телефона для получения кода подтверждения</p>
        </div>
          <form class="dialog__form" @submit.prevent="submitStepTwo(phone)">
            <div>
              <vita-input
                placeholder="Номер телефона"
                type="text"
                v-model="phone"
                @input="validatePhone"
                v-maska="'+7 (###) ###-##-##'"
                inputmode="numeric"
                data-maska-reversed
                :floating-label="true"
                ref="phoneInput"
                data-qa="restore-dialog-input-phone"
              />
            </div>
            <div>
              <vita-button :disabled="inProcess || isStepPassed(step)" :button-type="'submit'"
              data-qa="restore-dialog-button-next">Далее</vita-button>
              <div class="dialog__links">
                <a :class="{disabled: inProcess}" @click="goHomePage"
                 data-qa="restore-dialog-link-home">Главная страница</a>
              </div>
            </div>
          </form>
      </template>
      <template v-if="step === 3">
        <div class="dialog-head">
          <h3 class="dialog__title">Восстановление <br> пароля</h3>
          <p class="dialog__text">На номер телефона {{phone}} <br> отправлен смс-код с подтверждением</p>
        </div>
          <form class="dialog__form" @submit.prevent="submitStepThree(code)">
            <div>
              <div class="dialog__form-subtitle">Введите код из сообщения</div>
              <VitaCodeInput @pinCode="handlePinInput" ref="pinInputRef" />
              <div class="dialog__form-pin">
                <span v-if="timeLeft > 0">Отправить новый код <span class="timer">{{ formattedTime }}</span></span>
                <a v-else class="dialog__form-link" :class="{'disabled': inProcess}" @click.prevent="sendNewCode()"
                   data-qa="restore-dialog-link-resend-code">Отправить новый код</a>
              </div>
            </div>
            <div>
              <vita-button :disabled="inProcess || isStepPassed(step)" :button-type="'submit'"
              data-qa="restore-dialog-button-next">Далее</vita-button>
              <div class="dialog__links">
                <a :class="{disabled: inProcess}" @click="goHomePage"
                 data-qa="restore-dialog-link-home">Главная страница</a>
              </div>
            </div>
          </form>
      </template>
      <!--   Последний экран оставляем открытым до закрытия модального окна о завершении  -->
      <template v-if="step === 4 || step === 5">
        <div class="dialog-head">
          <h3 class="dialog__title">Придумайте <br> новый пароль</h3>
        </div>
        <form class="dialog__form" @submit.prevent="submitStepFour(newPassword)" autocomplete="off">
          <div>
            <vita-input
              placeholder="Новый пароль"
              :inputName="'new-password'"
              type="password"
              v-model="newPassword"
              :floating-label="true"
              data-qa="restore-dialog-input-new-password"
            />
            <vita-input
              placeholder="Повторите пароль"
              :inputName="'new-password'"
              type="password"
              v-model="newPasswordRetype"
              :floating-label="true"
              data-qa="restore-dialog-input-new-password-retype"
            />
            <VitaPasswordValidator :password-input="newPassword" @passwordValidity="passwordCheck"/>
            <div class="password-error">
              <span v-if="newPasswordRetype && (newPassword !== newPasswordRetype)">Пароли не совпадают</span>
            </div>
          </div>
          <div>
            <vita-button :disabled="inProcess || isStepPassed(step)" :button-type="'submit'"
              data-qa="restore-dialog-button-next">Далее</vita-button>
            <div class="dialog__links" v-if="!props.softReset">
              <a :class="{disabled: inProcess}" @click="goHomePage"
                 data-qa="restore-dialog-link-home">Главная страница</a>
            </div>
          </div>
        </form>
      </template>
    </div>
  </div>
  <vita-modal :title="modalTitle" v-if="openSuccessModal">
    <vita-button type="small" @click="finishPasswordChange"
      data-qa="restore-dialog-button-success-confirm">Ок</vita-button>
  </vita-modal>
  <vita-modal :title="error" v-if="error">
    <vita-button type="small" @click="closeErrorModal"
      data-qa="restore-dialog-button-error-close">Закрыть</vita-button>
  </vita-modal>
</template>

<script lang="ts" setup>
import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { vMaska } from "maska/vue"
import { useStore } from 'vuex';
import router from '@/router';
import VitaCodeInput from '@/components/UI/VitaCodeInput.vue';
import VitaPasswordValidator from '@/components/UI/VitaPasswordValidator.vue';
import { ResetPassword, StartResetPassword } from '@/store/user/types';
import { useTimer } from '@/utils/timer';
import { userLogout } from '@/utils/user';
import { reachGoal } from '@/utils/metrika';

interface Props {
  softReset?: boolean,
}
const props = defineProps<Props>()

const store = useStore()
const { timeLeft, startTimer } = useTimer(60);

const error = computed(() => {
  return store.getters['user/loginError']
})

// Шаги восстановления пароля
const step = computed(() => {
  return store.getters['user/getPasswordResetStep']
})

const inProcess = ref(false);
const email = ref("");
const snils = ref("");
const phone = ref("");
const phoneInput = ref<HTMLInputElement | null>(null);
const code = ref('');
const newPassword = ref("");
const newPasswordRetype = ref("");
const newPasswordsValid = ref(false);

// Таймер для отправки кода
const timerInterval = 0;

// Модальные окна
const openSuccessModal = ref(false)
const modalTitle = ref('Пароль успешно изменен')

const emailValid = ref(false);
const snilsValid = ref(false);
const phoneValid = ref(false);

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const snilsRegex = /^\d{3}-\d{3}-\d{3} \d{2}$/;
const phoneRegex = /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/;
const spaceKeyRegex = /\s/;

const pinInputRef = ref<InstanceType<typeof VitaCodeInput> | null>(null);
// Проверки для инпутов
const validateEmail = () => {
  emailValid.value = emailRegex.test(email.value);
};

const validateSnils = () => {
  snilsValid.value = snilsRegex.test(snils.value);
};

const validatePhone = () => {
  phoneValid.value = phoneRegex.test(phone.value);
};

// Проверка на заполненность для Email и СНИЛС
const isFormValid = computed(() => emailValid.value && snilsValid.value);

const onBackLinkClicked = () => {
  // Переходим на шаг назад
  store.dispatch('user/updatePasswordResetStep', step.value - 1)

  // Выход с первого шага на главную
  if (step.value === 0) router.push('/');

  // Убираем UID в sessionStorage в зависимости от шага
  if (step.value === 1) sessionStorage.removeItem('resetSessionUID')
  code.value = ''
}

// Получение пин-кода из инпутов
const handlePinInput = (pin: number | null) => {
  code.value = pin ? pin.toString() : ''
}

// Форматированный текст таймера
const formattedTime = computed<string>(() => {
  const minutes = Math.floor(timeLeft.value / 60);
  const seconds = timeLeft.value % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
});

const focusPinInput = () => {
  pinInputRef.value?.focusFirstInput();
};

// Функция для нового запроса
const sendNewCode = () => {
  const phoneValue = phone.value.replace(/[^+\d]/g, '');
  executeAction<string>('user/phoneInput', phoneValue);
  focusPinInput()
  startTimer()
};

// Проверка ввода нового пароля
const passwordCheck = (value: boolean) => {
  newPasswordsValid.value = value;
}

const newPasswordPairValid = (): boolean => {
  if (spaceKeyRegex.test(newPassword.value)) return false // Проверка на наличие пробела в пароле
  return newPasswordsValid.value && (newPassword.value === newPasswordRetype.value);
}

// Проверки для отключения кнопки перехода между шагами
const isStepPassed = (step: number): boolean => {
  switch (step) {
    case 1: return !isFormValid.value;
    case 2: return !phoneValid.value;
    case 3: return !code.value || code.value.length < 4;
    case 4: return !newPasswordPairValid()
    default: return false;
  }
}

async function executeAction<T>(action: string, payload?: T) {
  inProcess.value = true;
  try {
    await store.dispatch(action, payload);
  } catch (error) {
    console.error(`Произошла ошибка, `, error);
  } finally {
    inProcess.value = false;
    // При успешном изменении пароля показываем модальное окно
    if (step.value === 5) openSuccessModal.value = true
  }
}

const submitStepOne = (payload: StartResetPassword) => {
  executeAction<StartResetPassword>('user/startReset', payload);
}

const submitStepTwo = (phone: string) => {
  const phoneValue = phone.replace(/[^+\d]/g, '');
  executeAction<string>('user/phoneInput', phoneValue);
  startTimer();
};

const submitStepThree = (code: string) => executeAction<string>('user/confirmCode', code);

const submitStepFour = (password: string) => {
  if (props.softReset) {
    executeAction<ResetPassword>('user/resetPass', { newPassword: password, type: 'soft' })
    reachGoal('sidenav-password-change-action')
  } else {
    executeAction<ResetPassword>('user/resetPass', { newPassword: password, type: 'force' })
  }
};

const goHomePage = () => {
  store.commit('user/clearPasswordResetSteps')
  if (props.softReset && localStorage.getItem('token')) {
    userLogout()
  } else {
    router.push('/')
  }
}

const finishPasswordChange = () => {
  openSuccessModal.value = false
  goHomePage()
}

const closeErrorModal = () => {
  store.commit('user/setError', '')
}

watch(step, (newStep) => {
  // Фокус на input во втором шаге
  if (newStep === 2) {
    nextTick(() => {
      if (phoneInput.value) {
        phoneInput.value.focus();
      }
    });
  }
});

onMounted(() => {
  store.commit('user/clearPasswordResetSteps')
  if (props.softReset) {
    store.dispatch('user/updatePasswordResetStep', 4)
  }
})

onBeforeUnmount(() => {
  // Убираем таймер
  if (timerInterval) {
    clearInterval(timerInterval);
  }
});
</script>

<style scoped lang="scss">
@use '../static/style/variables.scss' as *;

.dialog-box {
  position: relative;
}

.dialog {
  padding: 20px 24px;
  max-width: 376px;
  min-height: 458px;
  text-align: center;
  background: $white;
  box-shadow: -1px 0px 12px 0px #00000026;
  border-radius: 3px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &__title {
    font-size: 22px;
    font-weight: 600;
    line-height: 27px;

    &:not(:last-child) {
      margin-bottom: 24px;
    }
  }

  &__links {
    margin-top: 18px;
    position: relative;
    font-size: 13px;

    a {
      display: block;
      color: $blue;
      font-weight: 500;
      cursor: pointer;
    }
  }

  &__tooltip {
    position: absolute;
    top: calc(100% + 45px);
    left: 50%;
    transform: translateX(-50%);
  }

  &__back {
    position: absolute;
    top: 20px;
    left: 24px;
    z-index: 1;
    cursor: pointer;
    color: #30A8FF;
  }

  &__form {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1 0 auto;

    .input-box + .input-box {
      margin-top: 24px;
      margin-bottom: 0;
    }
  }
}

.dialog {
  padding-bottom: 24px;
}

.dialog__form-link {
  display: inline-block;
  font-size: 12px;
  font-weight: 500;
  line-height: 14.63px;
  color: #30A8FF;
  cursor: pointer;
}

.dialog-box-restore {
  min-width: 376px;
}

.dialog__form-pin {
  margin-top: 20px;
  color: #888888;
  font-size: 12px;
  font-weight: 500;
  line-height: 14.63px;

  .timer {
    min-width: 35px;
    display: inline-block;
    text-align: left;
  }
}

.dialog__form-subtitle {
  font-size: 15px;
  font-weight: 400;
  line-height: 18.29px;
  margin-bottom: 10px;
  color: #888888;
}

.password-error {
  font-size: 12px;
  font-weight: 500;
  line-height: 14.63px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #FF3B30;
  margin-bottom: 15px;
  min-height: 15px;
}

.dialog-head {
  margin-bottom: 35px;
}

.disabled {
  color: rgba(136, 136, 136, .5);
  pointer-events: none;
}
</style>
